import clsx from "clsx";
import { useMainDrawerLinks } from "../MainDrawerLinks";
import { MainDrawerBodyRoot } from "./MainDrawerBody.styles";
import MainDrawerLink from "../MainDrawerLink/MainDrawerLink";
import { Col, useTheme } from "@commonlibs";

export interface MainDrawerBodyProps {
    className?: string;
    style?: React.CSSProperties;
    closeDrawer: () => void;
}

function MainDrawerBody({ className, closeDrawer, ...rest }: MainDrawerBodyProps) {
    const { spacing } = useTheme();
    const links = useMainDrawerLinks();

    return (
        <MainDrawerBodyRoot className={clsx("main-drawer-body", className)} gap={spacing["10"]} {...rest}>
            <Col gap={spacing[5]}>
                {links.map((linkProps) => {
                    return <MainDrawerLink closeDrawer={closeDrawer} {...linkProps} key={linkProps.label} />;
                })}
            </Col>
        </MainDrawerBodyRoot>
    );
}

export default MainDrawerBody;
